/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Criticality } from './Criticality';
import type { FilterConditionDto } from './FilterConditionDto';

export type CriticalityFilterConditionDto = (FilterConditionDto & {
    criticalities?: Array<Criticality>;
    operator?: CriticalityFilterConditionDto.operator;
} & {
    criticalities: Array<Criticality>;
    operator: CriticalityFilterConditionDto.operator;
});

export namespace CriticalityFilterConditionDto {

    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
